import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=44ef45c9&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=44ef45c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef45c9",
  null
  
)

export default component.exports